export default __webpack_public_path__ + "static/media/LosTiemposCambiaron.29139867.png";